/**
 * Card "Emergência" no Perfil: o que a pessoa quer que o grupo saiba se algo
 * acontecer. Tudo opcional. Quem divide uma viagem com ela vê no cartão
 * `/emergencia`; ninguém mais.
 */
import { useState } from 'react';

import { useGuardarEmergencia, useMinhaEmergencia, VAZIO, type Emergencia } from './api';

const CAMPOS: { chave: keyof Emergencia; rotulo: string; dica: string; tipo?: string; longo?: boolean }[] = [
  { chave: 'phone', rotulo: 'Meu telefone', dica: 'Com DDI, ex.: +55 11 99999-0000', tipo: 'tel' },
  { chave: 'contactName', rotulo: 'Contato de emergência', dica: 'Quem ligar por você' },
  { chave: 'contactPhone', rotulo: 'Telefone do contato', dica: '', tipo: 'tel' },
  { chave: 'healthNotes', rotulo: 'Saúde', dica: 'Alergias, remédios em uso, condições — o que quem está junto precisa saber', longo: true },
  { chave: 'insuranceName', rotulo: 'Seguro viagem', dica: 'Seguradora' },
  { chave: 'insurancePolicy', rotulo: 'Apólice', dica: '' },
  { chave: 'insurancePhone', rotulo: 'Telefone do seguro', dica: '', tipo: 'tel' },
];

export function EmergenciaNoPerfil() {
  const minha = useMinhaEmergencia();
  const guardar = useGuardarEmergencia();
  // O que a pessoa digitou fica por cima do que veio do servidor: a folha monta antes
  // de a consulta voltar, e a resposta não pode apagar um campo já preenchido.
  const [editados, setEditados] = useState<Partial<Emergencia>>({});
  const valores: Emergencia = { ...(minha.data ?? VAZIO), ...editados };
  const mudou = !!minha.data && CAMPOS.some((c) => (minha.data?.[c.chave] ?? '') !== (valores[c.chave] ?? ''));

  return (
    <>
      <p className="auth-note">Quem divide uma viagem com você vê isto no cartão de emergência — e só lá. Preencha o que quiser.</p>
      {CAMPOS.map((c) => (
        <label className="field" key={c.chave}>
          <span className="field__label">{c.rotulo.toUpperCase()}</span>
          {c.longo ? (
            <textarea className="field__input fb__texto" rows={3} value={valores[c.chave] ?? ''} placeholder={c.dica} onChange={(e) => setEditados((v) => ({ ...v, [c.chave]: e.target.value }))} data-testid={`emg-${c.chave}`} />
          ) : (
            <input className="field__input" type={c.tipo ?? 'text'} value={valores[c.chave] ?? ''} placeholder={c.dica} onChange={(e) => setEditados((v) => ({ ...v, [c.chave]: e.target.value }))} data-testid={`emg-${c.chave}`} />
          )}
        </label>
      ))}
      {guardar.isError && <p className="auth-error" role="alert">{guardar.error instanceof Error ? guardar.error.message : 'Não deu para guardar.'}</p>}
      <div className="fin__ctas">
        <button type="button" className="nv-btn nv-btn--primary" disabled={!mudou || guardar.isPending} onClick={() => guardar.mutate(valores)} data-testid="emg-guardar">
          {guardar.isPending ? 'Guardando…' : guardar.isSuccess && !mudou ? 'Guardado' : 'Guardar'}
        </button>
      </div>
    </>
  );
}
